import { render, staticRenderFns } from "./ViewTag.vue?vue&type=template&id=0def8f5f"
import script from "./ViewTag.vue?vue&type=script&lang=js"
export * from "./ViewTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports